import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogTrigger } from "@/components/ui/dialog";
import GpaScaleData from "./gpa-scales";
import { GpaScale } from "@/types/dashboard.types";

export function ScaleInfoDialog({ scale }: { scale: any }) {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant={"secondary"} className="h-full w-full">
          Scale Info
        </Button>
      </DialogTrigger>
      <DialogContent>
        <GpaScaleData data={scale as GpaScale[]} />
      </DialogContent>
    </Dialog>
  );
}
